// config.js
const API_HOST = 'https://backend.smartworkmanagement.com'; // Replace with your actual API host

export default API_HOST;
